<template>
  <el-dialog
    title=""
    :visible.sync="guideDialogVisible"
    width="386px"
    custom-class="dialog-clear-style"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    @open="guidShow"
    >
    <div class="wrap-c">
      <header v-show="viewGuide!=='skillview'" @click="handleBack">
        <img src="@/assets/image/icons/guide-back.png" alt="">
      </header>
      <div v-show="viewGuide==='skillview'" class="skill-con">
        <h3>{{$t('components_login_components_user_guide_1056')}}</h3>
        <h4>{{$t('components_login_components_user_guide_1057')}}</h4>
        <div class="skill-list">
          <skill-item @handleSellect="onSelectSkill" v-for="skillImg in skillImgs" :key="skillImg.label" :skillImgUrl='skillImg' :selected="selectedSkill.includes(skillImg.id)"></skill-item>
        </div>
      </div>
      <button class="primary-btn btn-confirm" v-if="selectedSkill.length&&viewGuide==='skillview'" @click="handleSellectSkill">
        {{$t('components_login_components_user_guide_1071')}}
      </button>
      <!-- <button class="primary-btn btn-confirm" v-else @click="skip">
        沒有感興趣的？去站內發掘更多精品->
      </button> -->
      <div v-show="viewGuide==='sexview'" class="skill-con">
        <h3>{{$t('components_login_components_user_guide_1058')}}</h3>
        <!-- <h4>讓nicee為您尋找最Match的男生/女生</h4> -->
        <div class="sex-list">
          <skill-item @handleSellect="handleSellectSex" v-for="sexImg in sexImgs" :key="sexImg.label" :skillImgUrl='sexImg'></skill-item>
        </div>
      </div>
      <!-- <div v-show="viewGuide==='matchview'" class="skill-con">
        <h3>準備好配對你的專屬陪玩師了嗎?</h3>
        <h4></h4>
        <div class="sex-list">
          <skill-item @handleSellect="handleSellectMatch" v-for="matchImg in matchImgs" :key="matchImg.label" :skillImgUrl='matchImg'></skill-item>
        </div>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/locales/index'
import skillItem from './skill-item'
import { mapGetters } from 'vuex'
import InviteRedbag from './invite-redbag'
import NewerREdBag from './newer-redbag'
import AmountCoponent from '@/components/common/amount/global-amount.jsx'
import { saveUserInfo } from '@/api'
const DisplayRedbag = AmountCoponent(InviteRedbag)
const DisplayNewerRedbag = AmountCoponent(NewerREdBag)
export default {
  name: 'userGuide',
  data() {
    const skillImgs = [
      { url: require('./images/skill-lol.png'), label:i18n.t('components_login_components_user_guide_1059'), id: 1 },
      { url: require('./images/skill-legend.png'), label:i18n.t('components_login_components_user_guide_1060'), id: 6 },
      { url: require('./images/skill-Special.png'), label:i18n.t('components_login_components_user_guide_1061'), id: 125 },
      { url: require('./images/skill-apex.png'), label:'APEX', id: 22 },
      { url: require('./images/skill-valo.png'), label:i18n.t('components_login_components_user_guide_1062'), id: 47 },
      { url: require('./images/skill-PUBG.png'), label:i18n.t('components_login_components_user_guide_1063'), id: 3 },
      { url: require('./images/skill-pubgm.png'), label:i18n.t('components_login_components_user_guide_1064'), id: 5 },
      { url: require('./images/skill-teamfight.png'), label:i18n.t('components_login_components_user_guide_1065'), id: 2 },
      { url: require('./images/skill-voice.png'), label:i18n.t('components_login_components_user_guide_1066'), id: 36 },
    ]
    const sexImgs = [
      { url: require('./images/male.png'), label:i18n.t('components_login_components_user_guide_1067'), id: 'Male' },
      { url: require('./images/female.png'), label:i18n.t('components_login_components_user_guide_1068'), id: 'Female' }
    ]
    const matchImgs = [
      { url: require('./images/match.png'), label:i18n.t('components_login_components_user_guide_1069'), id: 1 },
      { url: require('./images/stroll.png'), label:i18n.t('components_login_components_user_guide_1070'), id: 0 }
    ]
    return {
      skillText: '',
      viewGuide: 'skillview',
      skillId: '',
      skillImgs,
      sexImgs,
      matchImgs,
      selectedSkill: [],
      isSignUpInvite: false,
    }
  },
  created() {
    const webviewTime = this.$route.query.webview_starttime
    this.webviewTime = webviewTime || 0
  },
  computed: {
    ...mapGetters(['userInfo', 'guideDialogVisible']),
  },
  methods: {
    guidShow() {
      this.isSignUpInvite = this.$route.params.inviteCode
      console.log('inviteCod:', this.isSignUpInvite)
    },
    handleBack() {
      const viewGuide = this.viewGuide
      switch (viewGuide) {
        case 'sexview':
          // 打点 「陪玩師選擇」頁-返回-點擊
          this.$adjust('web_e_bchoice_return', {
            uuid: this.userInfo.uuid
          })
          this.viewGuide = 'skillview'
          break
        case 'matchview':
          // 打点 「立即匹配」頁-返回-點擊
          this.$adjust('web_e_readyornot_return', {
            uuid: this.userInfo.uuid
          })
          this.viewGuide = 'sexview'
          break
        default:
          break
      }
    },
    onSelectSkill(skillId) {
      let idx = this.selectedSkill.indexOf(skillId);
      if (idx > -1) {
        this.selectedSkill.splice(idx, 1);
      } else {
        this.selectedSkill.push(skillId);
      }
    },
    skip() {
      this.$store.dispatch('master/guideSelect', false);
      this.$adjust('game_select_zero', {
        uuid: this.userInfo.uuid
      })
    },
    handleSellectSkill() {
      let skillId = this.selectedSkill[0];
      this.$adjust('game_select', {
        from: this.selectedSkill,
        uuid: this.userInfo.uuid
      })
      const map = {
        1: {
          text: 'LOL',
          gameName: i18n.t('components_login_components_user_guide_1059')
        },
        6: {
          text: 'Legend',
          gameName: i18n.t('components_login_components_user_guide_1060')
        },
        22: {
          text: 'APEX',
          gameName: 'APEX'
        },
        47: {
          text: 'Valorant',
          gameName: i18n.t('components_login_components_user_guide_1062')
        },
        3: {
          text: 'Pubg',
          gameName: i18n.t('components_login_components_user_guide_1063')
        },
        5: {
          text: 'PubgM',
          gameName: i18n.t('components_login_components_user_guide_1064')
        },
        2: {
          text: 'Teamfight',
          gameName: i18n.t('components_login_components_user_guide_1065')
        },
        36: {
          text: 'Chat',
          gameName: i18n.t('components_login_components_user_guide_1066')
        },
        125: {
          text: 'WildRift',
          gameName: i18n.t('components_login_components_user_guide_1061')
        }
      }
      this.viewGuide = 'sexview'
      this.getCoupon(1)
      this.skillText = skillId ? map[skillId].text : 'none'
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
      this.skillId = skillId
      this.$http.post('/game/userCustom/save', {
        gameIds: this.selectedSkill,
      }).then(({ code }) => {
        if (code == 200) {
          this.$store.dispatch('app/getGamesList')
        }
      }).catch(() => {})
      this.$http.post('/myBoss/newBossAssign', {
        preferedGameVos: [{
          gameId: skillId,
          gameName: this.skillId ? map[this.skillId].gameName : null
        }]
      }).then(() => {}).catch(() => {});
      
      if(this.isSignUpInvite) {
        this.$adjust('invite_signin')
      }
    },
    handleSellectSex(sex) {
      // 打点 「陪玩師選擇」頁-陪玩類型選擇模塊-點擊
      saveUserInfo({sex})
      this.$store.dispatch('master/guideSelect', false)
      if(!this.isSignUpInvite) {
        DisplayNewerRedbag()
        return
      }
      // 簽約用戶邀請拉新成功
      this.waitCoupon()
      const dislogInstance = DisplayRedbag({
        on: {
          useCoupon: ()=>{
            this.$router.replace({
              path: '/'
            })
            dislogInstance.$destroy()
          }
        }
      })
      // this.viewGuide = 'matchview'
    },
    handleSellectMatch(id) {
      // 打点 「選擇遊戲」頁-遊戲模塊-點擊
      this.$adjust('web_e_gamechoice_button', {
        game_type: this.skillText,
        uuid: this.userInfo.uuid
      })
      // 打点 「立即匹配」頁-按钮
      this.$adjust('web_e_readyornot_button', {
        value: id ? 'ready' : 'notnow',
        uuid: this.userInfo.uuid
      })
      if (id && this.skillId) {
        this.$router.push(`/player-list/${this.skillId}`)
      } else {
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      }
      this.$store.dispatch('master/guideSelect', false)
    },
    /**
     * @description: 处理优惠券不能实时获取，通过信令通知
     * @param {*}
     * @return {*}
     */
    waitCoupon() {
      this.$util.setCallFn('EliteCouponNotice', ()=>{
        let coupon = this.$util.getVal(this.$store.state.app.accountInfo, 'couponInfoList.length')
        console.info('couponInfo: ' + coupon)
        if(!coupon) {
          this.$store.dispatch('app/getUserAccount')
        }
      })
    },
    /**
     * @description: 處理優惠信令無法收到的情況
     * @param {*} n
     * @return {*}
     */
    getCoupon(n) {
      let coupon = this.$util.getVal(this.$store.state.app.accountInfo, 'couponInfoList.length')
      if(n>4) return
      if(!coupon) {
        setTimeout(()=>{
          this.$store.dispatch('app/getUserAccount').then(()=>{
            this.getCoupon(++n)
          })
        }, n*1000)
      }
    }
  },
  watch: {
    viewGuide(newVal) {
      switch (newVal) {
        case 'skillview':
          this.$adjust('web_p_gamechoice_page', {
            uuid: this.userInfo.uuid
          })
          break
        case 'sexview':
          this.$adjust('web_p_bchoice_page', {
            uuid: this.userInfo.uuid
          })
          break
        case 'matchview':
          this.$adjust('web_p_readyornot_page', {
            uuid: this.userInfo.uuid
          })
          break
      }
    }
  },
  components:{
    skillItem
  }
}
</script>

<style lang="scss" scoped>
  header{
    @include flex(center, center);
    position: absolute;
    left: 12px;
    top: 12px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    &:hover{
      background: #E8EAEE;
    }
    img{
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }
  .wrap-c {
    position: relative;
    overflow: hidden;
    height: 678px;
    background: #ffffff;
    border-radius: 16px;
  }
  .skill-con{
    text-align: center;
    margin-top: 60px;
    h3{
      font-weight: 500;
      font-size: 22px;
      line-height: 31px;
      color: #222C43;
    }
    h4{
      font-size: 13px;
      line-height: 18px;
      color: #636D86;
      margin-top: 2px;
    }
    h3,h4{
      padding: 0 20px;
    }
  }
  .skill-list{
    padding: 0 27px;
    
    .skill-item{
      margin-left: 16px;
    }
  }
  .sex-list{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 150px;
    .skill-item {
      height: auto;
      width: 110px;
      margin: 0 25px;
      /deep/ img {
        height: 110px;
        width: 110px;
        margin-bottom: 8px;
      }
    }
    /deep/ .skill-shadow {
      height: 110px;
      width: 110px;
      border-radius: 50%;
    }
  }
  .skill-list{
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    .skill-item:nth-of-type(3n+1){
      margin-left: 0;
    }
  }
  .btn-confirm{
    margin: 0 auto;
    width: 343px;
    height: 48px;
    border-radius: 50px;
    @include flex;
  }
</style>
